// Strings de páginas e componentes — Português (pt-BR)
export const pages: Record<string, string> = {
  // COMMON
  loading: 'Carregando...',
  saving: 'Salvando...',
  deleting: 'Excluindo...',
  processing: 'Processando...',
  errorLabel: 'Erro',
  successLabel: 'Sucesso',
  notAuthenticated: 'Usuário não autenticado',
  tryAgain: 'Tente novamente',
  noData: 'Sem dados disponíveis',
  copiedToClipboard: 'Copiado para a área de transferência',
  requiredField: 'Campo obrigatório',
  invalidEmailMsg: 'E-mail inválido',
  loadingVideos: 'Carregando vídeos...',
  noVideosFound: 'Nenhum vídeo encontrado',
  unknownError: 'Erro desconhecido',
  confirmDelete: 'Confirmar exclusão',
  saveError: 'Erro ao salvar',
  loadingEllipsis: 'Carregando...',
  loadingDataEllipsis: 'Carregando dados...',

  // AUTH
  loginTitle: 'Acesse a sua conta',
  loginSubtitle: 'Tudo para escalar VSLs com automação, proteção e métricas.',
  loginSuccess: 'Login realizado com sucesso!',
  loginError: 'Erro ao fazer login. Verifique suas credenciais.',
  loginErrorGeneric: 'Erro ao fazer login. Tente novamente.',
  enterButton: 'Entrar',
  enteringButton: 'Entrando...',
  stayConnected: 'Continuar conectado',
  forgotPassword: 'Esqueceu sua senha?',
  noAccount: 'Não possui um cadastro?',
  createAccountFree: 'Crie sua conta agora!',
  signupTitle: 'Crie sua conta',
  signupSubtitle: 'E comece a transformar vídeos em conversões reais.',
  signupSuccess: 'Conta criada com sucesso! Agora escolha seu plano para começar.',
  signupError: 'Erro ao criar conta. Tente novamente.',
  acceptTermsError: 'Você precisa aceitar os termos de uso para continuar.',
  passwordError: 'As senhas precisam ser iguais.',
  userAlreadyExists: 'Este usuário já está tem contana plataforma.',
  nameTooShort: 'Nome deve ter pelo menos 2 caracteres.',
  invalidCPF: 'CPF inválido.',
  invalidWhatsApp: 'WhatsApp inválido.',
  passwordTooShort: 'Senha deve ter pelo menos 8 caracteres.',
  alreadyHaveAccount: 'Já possui uma conta?',
  loginHereLink: 'Faça login aqui',
  namePlaceholder: 'Nome completo',
  emailPlaceholder: 'hostvsl@email.com',
  passwordPlaceholder: 'Mín. 8 caracteres',
  emailLabel: 'E-mail',
  passwordLabel: 'Senha',
  passwordLabelMatch: 'Redigite a senha',
  acceptTermsLabel: 'Aceito os termos de uso e a política de privacidade',

  // DASHBOARD / MY VIDEOS
  deleteVideoSuccess: 'Vídeo excluído com sucesso!',
  deleteVideoError: 'Erro ao excluir vídeo',
  moveVideoSuccess: 'Vídeo movido para a pasta com sucesso!',
  moveVideoError: 'Erro ao mover vídeo para a pasta',
  videoRemovedFromFolder: 'Vídeo removido da pasta!',
  searchVideosPlaceholder: 'Buscar vídeos...',
  noVideosInFolder: 'Nenhum vídeo nesta pasta',
  newFolderLabel: 'Nova pasta',
  gridViewLabel: 'Visão em grade',
  listViewLabel: 'Visão em lista',
  myVideosPageTitle: 'Meus Vídeos',
  manageVideosSubtitle: 'Gerencie e visualize seus últimos vídeos',

  // A/B TEST
  incompleteConfig: 'Configuração incompleta',
  mainVideoNotSelected: 'Vídeo principal não selecionado',
  abTestActive: 'Seu teste A/B está ativo',
  videoSelectionTab: 'Seleção de vídeos',
  trafficDistributionTab: 'Distribuição de Tráfego',
  testDeletedMsg: 'Teste excluído',
  cannotDeleteTest: 'Não foi possível excluir o teste',
  createFirstABTest: 'Crie seu primeiro teste A/B',
  abTestEmptyDesc: 'Teste diferentes versões de suas VSLs e descubra o que converte mais',
  createABTestBtn: 'Criar Teste A/B',
  howItWorksLink: 'Como funciona?',
  trafficUpdatedSuccess: 'Distribuição atualizada',
  trafficUpdatedDesc: 'A distribuição de tráfego foi atualizada com sucesso',
  selectMinVideos: 'Selecione pelo menos 2 vídeos para o teste',
  selectMaxVideos: 'Selecione no máximo 6 vídeos para o teste',
  dateNotAvailable: 'Data não disponível',
  invalidDate: 'Data inválida',
  runningStatus: 'Em execução',
  finishedStatus: 'Finalizado',
  authError: 'Erro de autenticação',

  // HOOK TRACK
  hookTestActive: 'Seu teste de introduções está ativo',
  hookTrackEmptyDesc: 'Teste diferentes introduções e descubra qual retém mais a atenção',
  createFirstHookTest: 'Crie seu primeiro teste de hook',

  // VSLEADS
  loadStrategiesError: 'Erro ao carregar estratégias',
  strategyUpdatedToast: 'Estratégia atualizada',
  strategyUpdatedSuccessMsg: 'A estratégia foi atualizada com sucesso.',
  strategyRemovedToast: 'Estratégia removida',
  loadingStrategies: 'Carregando estratégias...',
  leadCaptureTitle: 'Captura de Leads',
  captureWithEmailLabel: 'Captura com E-mail',
  captureWithPasswordLabel: 'Captura com Senha',
  loadStrategyError: 'Erro ao carregar estratégia',
  strategyUpdateSuccess: 'Estratégia atualizada com sucesso ✅',
  updateStrategyError: 'Erro ao atualizar estratégia',
  protectedContent: 'Conteúdo protegido',
  accessVideoBtn: 'Acesse o vídeo',
  strategyCreated: 'Estratégia criada com sucesso',
  saveStrategyError: 'Erro ao salvar estratégia',

  // VSL CLOAKER
  loadVideosError: 'Erro ao carregar vídeos',
  loadRulesError: 'Erro ao carregar regras',
  selectOriginalVideo: 'Selecione o vídeo original',
  ruleCreated: 'Regra criada com sucesso',
  ruleDeleted: 'A regra foi excluída com sucesso',
  codesCopied: 'Código copiado!',
  cloakerEmptyTitle: 'Nenhuma regra criada',
  cloakerEmptyDesc: 'Crie regras para filtrar e redirecionar tráfego com base em critérios',

  // UPLOAD
  invalidFormat: 'Formato inválido',
  selectVideoFilesOnly: 'Selecione apenas arquivos de vídeo',
  videosAddedToast: 'Vídeos adicionados',
  uploadsCompleted: 'Uploads concluídos',
  maxFileSizeError: 'O arquivo deve ter no máximo 100MB',
  unsupportedFormatMsg: 'Formato não suportado',
  videoNameLabel: 'Nome do vídeo',
  continueToCustomize: 'Continue para personalizar seu vídeo',
  myVideoDefault: 'Meu Vídeo',

  // METRICS
  noRetentionData: 'Sem dados de retenção no período',
  noUTMData: 'Sem dados de UTM no período',
  expandPeriodTip: 'Tente ampliar o período',
  saveErrorMsg: 'Erro ao salvar',
  videoTimeLabel: 'Tempo do Vídeo',
  retentionLabel: 'Retenção (%)',

  // PLAYLIST
  playlistDeletedMsg: 'Playlist excluída',
  playlistLinkCopied: 'O link da playlist foi copiado',
  playlistNotFound: 'Playlist não encontrada',
  videosAddedMsg: 'Vídeos adicionados!',
  videoRemovedMsg: 'Vídeo removido',
  videosAddedSuccessDesc: 'Os vídeos foram salvos com sucesso.',
  embedCodeCopiedMsg: 'Código copiado!',
  embedCodeCopiedDesc: 'O código de incorporação foi copiado para a área de transferência.',
  logoCompressed: 'Logo otimizado',
  logoError: 'Erro ao comprimir logo',
  faviconError: 'Erro ao comprimir favicon',
  addVideosTitle: 'Adicione vídeos',

  // SHARE VIDEO
  settingsSaved: 'Configurações salvas!',
  generatingPublicLink: 'Gerando link público',
  activatingMetrics: 'Ativando métricas',
  videoPreparing: 'Vídeo em preparo',
  copiesLabel: 'cópias',
  copyLabel: 'cópia',

  // WEBINAR
  invalidWhatsAppField: 'WhatsApp inválido',
  registrationSuccess: 'Inscrição realizada!',
  redirectingToRoom: 'Você será redirecionado para a sala...',
  formError: 'Erro no formulário',

  // NOTIFICATIONS
  notificationsSaved: 'Preferências salvas',
  notificationsEnabled: 'Notificações ativadas!',
  notificationPermissionNeeded: 'Permissão necessária',
  testNotification: 'Notificação de teste',
  installAvailable: 'O HostVSL está sendo instalado',
  installInfo: 'Você pode acessar o HostVSL pela tela inicial',
  installNotAvailable: 'Instalação não disponível',

  // FEATURE CONFIGS
  urlInvalid: 'URL inválida',
  unsupportedImageFormat: 'Formato não suportado. Use PNG ou JPG',
  thumbnailConfigured: 'A thumbnail de início foi configurada',
  buttonAdded: 'Botão adicionado',
  buttonRemoved: 'Botão removido',
  videoIdNotFound: 'ID do vídeo não encontrado',

  // DASHBOARD EMPTY STATES
  emptyDashboardTitle: 'Nenhum vídeo encontrado',
  emptyDashboardSubtitle: 'Envie seu primeiro vídeo para começar',
  uploadFirstVideo: 'Enviar primeiro vídeo',

  // PROFILE
  profileSaved: 'Perfil salvo',
  passwordChangedSuccess: 'Senha alterada com sucesso',
  photoChangedSuccess: 'Foto alterada',
  photoRemovedSuccess: 'Foto removida',

  // PIXEL
  pixelPageTitle: 'Configuração de Pixel',
  pixelPageSubtitle: 'Configure pixels de rastreamento para monitorar conversões',

  // METRICS PAGE
  metricsPageTitle: 'Métricas',
  selectVideoMetrics: 'Selecione um vídeo para ver as métricas',

  // DOMAIN PROTECTION
  domainProtectionTitle: 'Proteção de Domínios',

  // TRACKING
  trackingTitle: 'Rastreamento',

  // FINANCE
  financeTitle: 'Financeiro',

  // PARTNERS
  partnersTitle: 'Parceiros',

  // NOT FOUND
  pageNotFound: 'Página não encontrada',
  goHome: 'Voltar ao início',

  // AB TEST LIST
  abTestListTitle: 'Seus Testes A/B',
  createNewTest: 'Criar novo teste',
  noABTestsFound: 'Nenhum teste A/B encontrado',
  createFirstABTestDesc: 'Crie seu primeiro teste A/B para comparar diferentes versões de vídeos.',
  copyCode: 'Copiar Código',
  rename: 'Renomear',
  viewMetrics: 'Ver Métricas',
  deleteABTestTitle: 'Excluir teste A/B?',
  deleteTestConfirm: 'Esta ação irá excluir permanentemente este teste e todos os seus dados. Esta ação não pode ser desfeita.',
  confirmDeleteTest: 'Sim, excluir teste',
  abTestCodeCopiedDesc: 'O código do teste A/B foi copiado para a área de transferência.',
  abTestDeletedDesc: 'O teste A/B foi excluído com sucesso.',
  deleteErrorTitle: 'Erro ao excluir',
  testRenamedTitle: 'Teste renomeado',
  testRenamedDesc: 'O nome do teste foi atualizado com sucesso.',
  renameErrorTitle: 'Erro ao renomear',
  renameTestError: 'Não foi possível renomear o teste.',
  copyCodeErrorTitle: 'Erro ao copiar código',
  noVideosInTest: 'Este teste não possui vídeos associados.',
  featureInDevelopment: 'Em desenvolvimento',
  toggleStatusDev: 'Função de ativar/desativar em desenvolvimento.',
  duplicateDev: 'Função de duplicar em desenvolvimento.',

  // HOOK TRACK LIST
  hookTrackListTitle: 'Seus Testes de Introduções',
  createHookTest: 'Criar Teste de Hook',
  noHookTestsDesc: 'Você ainda não criou nenhum teste de hook.',
  createFirstHookLabel: 'Criar seu primeiro teste',
  deleteHookTestTitle: 'Excluir teste de hook?',
  hookTestDeletedDesc: 'O teste foi excluído com sucesso.',
  hookRenameTestError: 'Não foi possível atualizar o nome do teste.',
  statusUpdatedTitle: 'Status atualizado',
  statusUpdatedDesc: 'O status do teste foi atualizado.',
  duplicateSoon: 'Funcionalidade de duplicação em breve.',
  testWithoutName: 'Teste sem nome',

  // MY VIDEOS V2
  removeFromFolderError: 'Erro ao remover vídeo da pasta',
};
